import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 500 500"
    xmlSpace="preserve"
    width="1em"
    height="1em"
  >
    <circle cx={250} cy={250} r={250} fill="#30302f" />
    <path
      fill="#595a5c"
      d="M243.744 75.405L174.4 222.622l54.795 30.24zM220.171 363.089l-3.676 47.359-108.23-47.36 37.962-80.628 77.92 31.98z"
    />
    <path fill="#929497" d="M386.81 363.089l-163.222 47.359 3.485-47.36 23.69-287.683z" />
    <g>
      <path fill="#801518" d="M228.776 257.972l-56.155-31.573-6.914 14.678 61.882 31.377z" />
      <path fill="#be2327" d="M227.22 276.965l-63.412-31.856-6.843 14.528 69.073 31.732z" />
      <path fill="#dc4627" d="M224.485 309.988l-76.36-31.585 6.89-14.628 70.664 31.975z" />
    </g>
    <g>
      <path fill="#801518" d="M408.424 166.459V125.36l-106.978 43.067 13.193 27.245z" />
      <path fill="#be2327" d="M408.424 214.553V174.97l-90.907 26.647L330.74 228.8z" />
      <path fill="#dc4627" d="M408.424 223.152v39.517l-61.336.017-13.086-27.026z" />
    </g>
  </svg>
);

const Flowjo = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Flowjo;
